import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";

const TextInputComponent = forwardRef(
  (
    {
      label,
      name,
      value,
      onChange,
      type = "text",
      error,
      helperText,
      required = false,
      onBlur,
      onKeyDown,
      readOnly = false,
      multiline = false,
      minRows = 4,
      maxRows = 10,
      placeholder,
      ...props // <-- 1. Accept all other props
    },
    ref
  ) => {

    const isRangedNumber = type === 'number' && 
    props.inputProps?.min !== undefined && 
    props.inputProps?.max !== undefined;

    // NEW LOGIC: Define the styles to hide the number input arrows
    const hideNumberSpinners = {
    // Hide spin buttons on Chrome, Safari, Edge, Opera
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
    },
    // Hide spin buttons on Firefox
    '& input[type=number]': {
    '-moz-appearance': 'textfield',
    },
    };

    return (
      <TextField
        fullWidth
        label={label}
        name={name}
        type={type}
        value={value ?? ''} // Handle null/undefined values gracefully
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        required={required}
        error={!!error}
        helperText={helperText} // Pass helperText directly
        placeholder={placeholder}
        multiline={multiline}
        minRows={multiline ? minRows : undefined}
        maxRows={multiline ? maxRows : undefined}
        inputRef={ref}
        sx={{
          marginBottom: 2,
          ...(type === 'number' && !isRangedNumber && hideNumberSpinners),
        }}
        InputProps={{
          readOnly: readOnly,
          ...props.InputProps, // Merge with incoming InputProps for the calendar icon
        }}
        {...props} // <-- 2. Spread all other props here
      />
    );
  }
);

export default TextInputComponent;